import { __, sprintf } from '@wordpress/i18n';

; (() => {
    document.addEventListener('DOMContentLoaded', () => {

        // Sticks the filter to the top of the page.
        const filters = document.querySelectorAll('.wpte-fsd_dc__filter');

        // Calculate heights and initial offsets once on load
        const filterData = [...filters].map(filter => {
            const filterDates = filter.querySelector('.wpte-fsd_dc__filter-by-dates');
            return {
                element: filter,
                filterDates: filterDates,
                height: filterDates ? filterDates.offsetHeight : 0,
                initialOffset: filter.getBoundingClientRect().top + window.scrollY,
                parentElement: filter.parentElement,
                isSticky: false
            };
        });

        let ticking = false;

        const handleScroll = () => {
            if (ticking) return;

            ticking = true;
            window.requestAnimationFrame(() => {
                const scrollY = window.scrollY;

                filterData.forEach(data => {
                    const stickyEnabled = data.element.getAttribute('data-sticky-enabled') === 'true';
                    if (!stickyEnabled) return;

                    // Calculate if we should be sticky (scrolled past initial position)
                    const shouldBeSticky = scrollY >= data.initialOffset;

                    // Calculate if we've scrolled past the parent container (unsticky at bottom)
                    const parentRect = data.parentElement.getBoundingClientRect();
                    const parentBottom = parentRect.top + parentRect.height;
                    const shouldUnstickAtBottom = parentBottom <= data.height;

                    // Determine final sticky state
                    const newStickyState = shouldBeSticky && !shouldUnstickAtBottom;

                    // Only update DOM if state actually changed
                    if (newStickyState !== data.isSticky) {
                        data.isSticky = newStickyState;

                        if (newStickyState) {
                            data.element.classList.add('wpte-fsd_dc__filters-sticky');
                            data.parentElement.style.paddingTop = data.height + 16 + 'px';
                        } else {
                            data.element.classList.remove('wpte-fsd_dc__filters-sticky');
                            data.parentElement.style.paddingTop = '0px';
                        }
                    }
                });

                ticking = false;
            });
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        // Smart scroll with offset to account for fixed headers
        const scrollToElement = (element) => {
            if (!element) return;

            // Get computed CSS variables for offsets
            const filter = element.querySelector('.wpte-fsd_dc__filter');
            const computedStyle = filter ? window.getComputedStyle(filter) : null;

            const getConfiguredOffset = () => {
                if (!computedStyle) return 0;

                const width = window.innerWidth;
                let varName;

                if (width >= 1025) {
                    varName = '--wpte-fsd_dc-offset-top_desktop';
                } else if (width >= 768) {
                    varName = '--wpte-fsd_dc-offset-top_tablet';
                } else {
                    varName = '--wpte-fsd_dc-offset-top_mobile';
                }

                const value = computedStyle.getPropertyValue(varName);
                return parseInt(value) || 0;
            };

            // Calculate total offset (configured offset + breathing room)
            const configuredOffset = getConfiguredOffset();
            const totalOffset = configuredOffset + 20; // +20px breathing room

            // Calculate target scroll position
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const targetPosition = elementPosition - totalOffset;

            // Smooth scroll to position
            window.scrollTo({
                top: Math.max(0, targetPosition),
                behavior: 'smooth'
            });
        };

        const isActive = (el) => el?.classList.contains('is-active');
        const getActiveBtn = (el) => el?.querySelector('button.is-active');
        const filterByYear = () => document.querySelector('.wpte-fsd_dc__filter-by-year');
        const filterByMonth = () => document.querySelector('.wpte-fsd_dc__filter-by-month');
        const favoriteButtons = () => document.querySelectorAll('.wpte-fsd_dc__tour-favorite-button');
        const paginationWrap = () => document.querySelector('.wpte-fsd_dc__pagination_wrap');
        const mapTogglerButtons = () => document.querySelectorAll('.wpte-fsd_dc__tour-map-toggler-button');
        const filterSearch = document.querySelector('.wpte-fsd_dc__filter-by-query input[type="search"]');
        const filterViewMode = document.querySelector('.wpte-fsd_dc__filter-by-query .wpte-fsd_dc__layout-mode');

        let mainParent = null;
        let previousViewMode = getActiveBtn(filterViewMode)?.getAttribute('data-layout') || wptravelengine_fsd_dc?.settings?.default_layout;

        const debounce = (func, delay) => {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        };

        // fallback message
        function fallbackMessage({ title, message, siblingElement }, isActive = true) {
            const container = siblingElement?.closest('.wpte-fsd_dc') || siblingElement?.parentElement;
            if (!container) return;

            const existingFallback = container.querySelector('.wpte-fsd_dc__fallback-message');

            if (!isActive) {
                if (existingFallback) {
                    existingFallback.remove();
                }
                container.querySelectorAll('[data-fsd-hidden]').forEach(el => {
                    el.removeAttribute('data-fsd-hidden');
                    el.style.display = '';
                });
                return;
            }

            if (!existingFallback) {
                const i18n = wptravelengine_fsd_dc.i18n;

                const heading = document.createElement('h3');
                heading.className = 'wpte-fsd_dc__fallback-title';
                heading.innerHTML = title || i18n.no_results;

                const para = document.createElement('p');
                para.className = 'wpte-fsd_dc__fallback-text';
                para.textContent = message || i18n.adjust_search;

                const content = document.createElement('div');
                content.className = 'wpte-fsd_dc__fallback-content';
                content.appendChild(heading);
                content.appendChild(para);

                const fallbackDiv = document.createElement('div');
                fallbackDiv.className = 'wpte-fsd_dc__fallback-message';
                fallbackDiv.appendChild(content);

                const filter = container.querySelector('.wpte-fsd_dc__filter');
                if (filter) {
                    filter.parentNode.insertBefore(fallbackDiv, filter.nextSibling);
                } else {
                    container.insertBefore(fallbackDiv, container.firstChild);
                }
            }

            // Hide all siblings after the fallback message.
            const fallback = container.querySelector('.wpte-fsd_dc__fallback-message');
            let el = fallback?.nextElementSibling;
            while (el) {
                el.setAttribute('data-fsd-hidden', '');
                el.style.display = 'none';
                el = el.nextElementSibling;
            }
        }

        // Main api call function.
        const fetchDepartureCalendar = async (data = {}, rest = {}) => {
            const {
                month = getActiveBtn(filterByMonth())?.getAttribute('data-month'),
                year = getActiveBtn(filterByYear())?.getAttribute('data-year'),
                viewMode = previousViewMode,
                currentPage = 1,
                search = filterSearch?.value || '',
            } = data;

            const params = new URLSearchParams({
                action: 'wptravelengine_fsd_dc_ajax_',
                nonce: wptravelengine_fsd_dc.nonce,
                viewMode,
                month,
                year,
                search,
                settings: JSON.stringify(wptravelengine_fsd_dc.settings),
                currentPage,
                ...rest
            });

            const res = await fetch(`${wptravelengine_fsd_dc.ajax_url}?${params.toString()}`).then(res => res.json());

            return {
                ...res,
                urlParams: {
                    mnth: month,
                    yr: year,
                    viewMode,
                    search,
                },
            };
        }

        // After fetch callback.
        const afterFetch = (res) => {
            const { success, data: { html, view_mode, pagination_markup, trips_count = 0, message: errorMessage } } = res;
            if (success) {
                const htm = new DOMParser().parseFromString(html, 'text/html');

                mainParent.querySelector('.wpte-fsd_dc__grid, .wpte-fsd_dc__list')?.replaceWith(htm.body.firstChild);

                const urlParams = new URLSearchParams(window.location.search);
                Object.entries(res.urlParams).forEach(([key, value]) => {
                    if (value) {
                        urlParams.set(key, value);
                    } else {
                        urlParams.delete(key);
                    }
                });
                window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);

                initMapToggler();
                handleFavoriteButton();
                collapsibleMeta();

                const newLayout = mainParent.querySelector('.wpte-fsd_dc__grid, .wpte-fsd_dc__list');
                const i18n = wptravelengine_fsd_dc.i18n;
                fallbackMessage({
                    title: i18n.no_trips_found,
                    message: i18n.adjust_search,
                    siblingElement: mainParent,
                }, trips_count === 0);
                newLayout?.setAttribute('data-trips-count', trips_count);

                if (pagination_markup) {
                    const htm = new DOMParser().parseFromString(pagination_markup, 'text/html');
                    mainParent.querySelector('.wpte-fsd_dc__pagination_wrap')?.replaceWith(htm.body.firstChild);
                    handlePagination();
                }
            } else {
                const i18n = wptravelengine_fsd_dc.i18n;
                fallbackMessage({
                    title: i18n.error,
                    message: i18n.error_message,
                    siblingElement: mainParent,
                });
            }
            return res;
        }

        // On Month change.
        const filterMonth = () => {
            filterByMonth()?.addEventListener('click', async (e) => {
                if (e.target.tagName !== 'BUTTON' || isActive(e.target)) return;
                e.preventDefault();
                mainParent = e.target.closest('.wpte-fsd_dc');
                mainParent.classList.add('wpte-fsd_dc__is-loading');

                try {
                    const { success } = await fetchDepartureCalendar({
                        month: e.target.getAttribute('data-month'),
                        year: getActiveBtn(filterByYear())?.getAttribute('data-year'),
                    }, { getPagination: true }).then(afterFetch);
                    if (!success) return;

                    scrollToElement(mainParent);
                    getActiveBtn(filterByMonth())?.classList.remove('is-active');
                    e.target.classList.add('is-active');
                } catch (error) {
                    console.error('Month fetch failed:', error);
                } finally {
                    mainParent.classList.remove('wpte-fsd_dc__is-loading');
                }
            });
        }

        // On Year change.
        filterByYear()?.addEventListener('click', async (e) => {
            if (e.target.tagName !== 'BUTTON' || isActive(e.target)) return;
            e.preventDefault();
            mainParent = e.target.closest('.wpte-fsd_dc');
            mainParent.classList.add('wpte-fsd_dc__is-loading');

            try {
                const { success, data: { filter_dates_html } } = await fetchDepartureCalendar({
                    year: e.target.getAttribute('data-year'),
                    month: null,
                }, { getPagination: true }).then(afterFetch);
                if (!success) return;

                const htm = new DOMParser().parseFromString(filter_dates_html, 'text/html');
                mainParent.querySelector('.wpte-fsd_dc__filter-by-dates .wpte-fsd_dc__filter-by-month')?.replaceWith(htm.body.firstChild);
                scrollToElement(mainParent);
                filterMonth();
                handleSelectFilters();
                getActiveBtn(filterByYear())?.classList.remove('is-active');
                e.target.classList.add('is-active');
            } catch (error) {
                console.error('Year fetch failed:', error);
            } finally {
                mainParent.classList.remove('wpte-fsd_dc__is-loading');
            }
        });
        filterMonth();

        // Handle mobile select dropdowns.
        const handleSelectFilters = () => {
            const yearSelect = document.querySelector('.wpte-fsd_dc__filter-select-year');
            const monthSelect = document.querySelector('.wpte-fsd_dc__filter-select-month');

            yearSelect?.addEventListener('change', (e) => {
                // Find the corresponding button and trigger its click
                const targetButton = filterByYear()?.querySelector(`[data-year="${e.target.value}"]`);
                if (targetButton && !targetButton.classList.contains('is-active')) {
                    targetButton.click();
                }
            });

            monthSelect?.addEventListener('change', (e) => {
                // Find the corresponding button and trigger its click
                const targetButton = filterByMonth()?.querySelector(`[data-month="${e.target.value}"]`);
                if (targetButton && !targetButton.classList.contains('is-active')) {
                    targetButton.click();
                }
            });
        };

        // Initialize select handlers
        handleSelectFilters();

        // On Search input.
        filterSearch?.addEventListener('input', debounce(async (e) => {
            e.preventDefault();
            mainParent = e.target.closest('.wpte-fsd_dc');
            mainParent.classList.add('wpte-fsd_dc__is-loading');

            try {
                await fetchDepartureCalendar({}, { getPagination: true }).then(afterFetch);
            } catch (error) {
                console.error('Search fetch failed:', error);
            } finally {
                mainParent.classList.remove('wpte-fsd_dc__is-loading');
            }
        }, 1000));

        // On View Mode change.
        filterViewMode?.querySelectorAll('button')?.forEach(button => button.addEventListener('click', async (e) => {
            e.preventDefault();
            const btn = e.target.closest('button');
            if (isActive(btn)) return;
            const viewMode = btn.getAttribute('data-layout');
            mainParent = e.target.closest('.wpte-fsd_dc');
            mainParent.classList.add('wpte-fsd_dc__is-loading');

            const currentPage = parseInt(paginationWrap()?.getAttribute('data-current-page'), 10);

            try {
                const { success } = await fetchDepartureCalendar({ viewMode, currentPage }).then(afterFetch);
                if (!success) return;
                getActiveBtn(filterViewMode)?.classList.remove('is-active');
                btn.classList.add('is-active');
                previousViewMode = viewMode;
            } catch (error) {
                console.error('View mode change failed:', error);
            } finally {
                mainParent.classList.remove('wpte-fsd_dc__is-loading');
            }
        }));

        // On Favorite button click.
        function handleFavoriteButton() {
            favoriteButtons()?.forEach(button => button.addEventListener('click', async (e) => {
                e.preventDefault();
                const target = e.currentTarget;
                mainParent = target.closest('.wpte-fsd_dc');
                mainParent.classList.add('wpte-fsd_dc__is-loading');
                const myParent = target.closest('.wpte-fsd_dc__tour');
                const wishlist = myParent.getAttribute('data-trip-id');
                const isActive = target.classList.contains('is-active');

                try {
                    const { success } = await fetchDepartureCalendar({}, {
                        wishlist,
                        isAlreadyInWishlist: isActive,
                    });
                    if (!success) return;

                    mainParent.querySelectorAll('.wpte-fsd_dc__tour')?.forEach(_t => {
                        if (_t.getAttribute('data-trip-id') === wishlist) {
                            _t.querySelector('.wpte-fsd_dc__tour-favorite-button')?.classList.toggle('is-active', !isActive);
                        }
                    });
                } catch (error) {
                    console.error('Favorite button fetch failed:', error);
                } finally {
                    mainParent.classList.remove('wpte-fsd_dc__is-loading');
                }
            }));
        }
        handleFavoriteButton();

        // On Show More and Show Less click.
        function handlePagination() {
            paginationWrap()?.querySelectorAll('button')?.forEach(button => button.addEventListener('click', async (e) => {
                e.preventDefault();
                mainParent = e.target.closest('.wpte-fsd_dc');
                mainParent.classList.add('wpte-fsd_dc__is-loading');

                const myParent = e.target.closest('.wpte-fsd_dc__pagination_wrap');
                const isShowMore = e.target.hasAttribute('data-show-more');

                const topBtn = isShowMore ? e.target : e.target.previousElementSibling;
                const bottomBtn = isShowMore ? e.target.nextElementSibling : e.target;

                topBtn.disabled = true;
                bottomBtn.disabled = true;

                let currentPage = parseInt(myParent.getAttribute('data-current-page'), 10);
                currentPage = isShowMore ? currentPage + 1 : currentPage - 1;

                try {
                    const { success } = await fetchDepartureCalendar({ currentPage }).then(afterFetch);
                    if (!success) return;

                    const maxPage = parseInt(myParent.getAttribute('data-max-page'), 10);
                    myParent.setAttribute('data-current-page', currentPage);
                    topBtn.style.display = currentPage < maxPage ? '' : 'none';
                    bottomBtn.style.display = currentPage > 1 ? '' : 'none';
                } catch (error) {
                    console.error('Pagination fetch failed:', error);
                } finally {
                    mainParent.classList.remove('wpte-fsd_dc__is-loading');
                    topBtn.disabled = false;
                    bottomBtn.disabled = false;
                }
            }));
        }
        handlePagination();

        // On Map toggler button click.
        function initMapToggler() {
            mapTogglerButtons()?.forEach(button => button.addEventListener('click', (e) => {
                const target = e.currentTarget;
                const parent = target.parentElement;
                target.classList.toggle('is-active');
                parent.classList.toggle('is-map-open');
            }));
        }
        initMapToggler();

        // Collapsible Meta
        function collapsibleMeta() {
            const metaButtons = document.querySelectorAll('.wpte-show-more-less-button');
            if (!metaButtons) return;
            metaButtons.forEach(button => {
                const parent = button.parentNode;
                const initialCount = Number(parent.getAttribute('data-initial-count'));
                const totalLinks = parent.querySelectorAll('a').length;
                const totalMoreLinks = totalLinks - initialCount;
                parent.classList.add('is-collapsible-meta');
                button.innerText = sprintf(wptravelengine_fsd_dc.i18n.more, totalMoreLinks);
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    const isShowAll = parent.classList.contains('show-all');
                    parent.classList.toggle('show-all', !isShowAll);
                    button.innerText = isShowAll ? sprintf(wptravelengine_fsd_dc.i18n.more, totalMoreLinks) : wptravelengine_fsd_dc.i18n.hide;
                });
            });
        }
        collapsibleMeta();

        // Trigger fallback on initial page load if no trips are rendered.
        document.querySelectorAll('.wpte-fsd_dc').forEach(container => {
            if (!container.querySelector('.wpte-fsd_dc__tour')) {
                fallbackMessage({
                    title: wptravelengine_fsd_dc.i18n.no_trips_found,
                    message: wptravelengine_fsd_dc.i18n.no_dates,
                    siblingElement: container,
                });
            }
        });
    })
})();